import React, { useEffect, useRef, useState } from "react"
import Esign from "../Esign"
import { useParams } from "react-router-dom"
import useToggle from "../../../../hooks/toggle"
import { selecteddocumentesign } from "../ReviewDocs"
import { useReactToPrint } from "react-to-print"
import { getexternaldocuments, getSavedOfferDetails, SaveInspectionAuthorization } from "../../../../api/transaction"
import { useSelector } from "react-redux"
import { CSpinner } from "@coreui/react"
const ReqInspectionAuth = ()=>{
    const params:{id:any,user:string} = useParams()
    const{id,user} = params
    const [loader,setloading] = useState(false)
    const [inspect,SetInspect] = useState({
        offer_id :id,
        buyer :"",
        seller :"",
        property_address :"",
        contract_date :"",
        whole_inspection_input1 :"",
        whole_inspection_input2 :"",
        whole_inspection_performedby :"",
        termite_wood_input1 :"",
        termite_wood_input2 :"",
        termite_wood_performedby :"",
        mold_input1 :"",
        mold_input2 :"",
        mold_performedby :"",
        radon_input1 :"",
        radon_input2 :"",
        radon_performedby :"",
        furnace_air_condition_input1 :"",
        furnace_air_condition_input2 :"",
        furnace_air_condition_performedby :"",
        well_and_septic_input1 :"",
        well_and_septic_input2 :"",
        well_and_septic_performedby :"",
        sewer_line_input1 :"",
        sewer_line_input2 :"",
        sewer_line_performedby :"",
        other_input1 :"",
        other_input2 :"",
        other_performedby :"",
        buyer1_signature :null,
        buyer1_signature_date :"",
        buyer2_signature :"",
        buyer2_signature_date :"",
        seller1_signature :null,
        seller1_signature_date :"",
        seller2_signature :"",
        seller2_signature_date :""
    })
 
        const componentRef = useRef();
    const [canvasmodal, setCanvasModal] = useToggle(false);
    const [htmlContent, setHtmlContent] = useState("");
    const [selecteddocumentesign, setselectedDocumentEsign] = useState<selecteddocumentesign>({
        offerid : "",
      document_name: "",
      image_base64: "",
      sign_role: 1
      })
      const [offerdetails, setOfferDetails]:any = useState({});
      const printf = () => {
        handlePrint()
    };
    // @ts-ignore
    const val = useSelector((state) => state?.new?.signset)
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });
    
    useEffect(()=>{
      if(val){
          if(user == "seller"){
            SetInspect({ ...inspect, seller1_signature: val }) 
          }
          if(user == "client"){
            SetInspect({ ...inspect, buyer1_signature: val }) 
          }
      }
      },[val])

    const send = async()=>{
     setloading(true)
      if(user==="client"){
    
        if (inspect?.buyer1_signature) {
            const res = await SaveInspectionAuthorization(inspect)
            if(res?.status == "success"){
              alert("Submitted Successfully")
          }
          else{
              alert("Something went wrong")
          }
        }
    }
    if(user==="seller"){
   
      if (inspect?.seller1_signature) {

          const res = await SaveInspectionAuthorization(inspect)
          if(res?.status == "success"){
            alert("Submitted Successfully")
        }
        else{
            alert("Something went wrong")
        }
      }
  }
  setloading(false)
       }   
    
    useEffect(()=>{
    (async function() {
        let offerdetails = await getSavedOfferDetails(id)
        setOfferDetails(offerdetails[0])
        const res =await getexternaldocuments(id,"inspectionauthorization") 
        SetInspect({...inspect,
          buyer1_signature :res?.data?.buyer1_signature ,
          buyer1_signature_date: res?.data?.buyer1_signature_date,
          seller1_signature_date: res?.data?.seller1_signature_date,
          seller1_signature :res?.data?.seller1_signature ,
        })

    })()
    
    },[])
  

    return (
        // <div dangerouslySetInnerHTML={{ __html: formHtml }} />
        <>
<>
  <meta charSet="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <link rel="preconnect" href="https://fonts.googleapis.com" />
  <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
  <link
    href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600&display=swap"
    rel="stylesheet"
  />
  <style
    dangerouslySetInnerHTML={{
      __html:
        '\n        * {\n            font-family: "Poppins", sans-serif;\n        }\n    '
    }}
  />
  <title>Document</title>
  <table
    style={{
      width: 1100,
      margin: "0 auto",
      background: "#fff",
      padding: 15,
      fontSize: 14
    }}
  >
    <tbody>
      <tr>
        <td>
          <table style={{ width: "100%" }}>
            <tbody>
              <tr>
                <td style={{ width: "90%" }}>
                  <img
                    style={{ width: 250 }}
                    src="https://storagemilforddev.blob.core.windows.net/images/logo.svg"
                  />
                </td>
                <td>
                  <img
                    style={{ width: 40, marginRight: 15 }}
                    src="https://storagemilforddev.blob.core.windows.net/images/realtor.svg"
                    alt=""
                  />
                  <img
                    style={{ width: 50 }}
                    src="https://storagemilforddev.blob.core.windows.net/images/eh.svg"
                    alt=""
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
      <tr>
        <td>
          <span style={{ fontSize: 18, fontWeight: 700 }}>
            Authorization to Obtain Inspections and/or Services
          </span>
        </td>
      </tr>
      <tr>
        <td>
          <span style={{ fontWeight: 600 }}>
            BUYER:
            <input
              type="text"/* @ts-ignore */
              value={offerdetails?.leadName}
              // onChange={(e)=>{SetInspect({...inspect,buyer:e?.target?.value})}}
              style={{
                outline: "none",
                border: "none",
                borderBottom: "1px solid black",
                width: "90%"
              }}
            />
          </span>
        </td>
      </tr>
      <tr>
        <td>
          <span style={{ fontWeight: 600 }}>
            SELLER:
            <input
              type="text"
              value={inspect?.seller}
              onChange={(e)=>{SetInspect({...inspect,seller:e?.target?.value})}}
              style={{
                outline: "none",
                border: "none",
                borderBottom: "1px solid black",
                width: "90%"
              }}
            />
          </span>
        </td>
      </tr>
      <tr>
        <td>
          <span style={{ fontWeight: 600 }}>
            PROPERTY:
            <input
              type="text"
              value={inspect?.property_address}
              onChange={(e)=>{SetInspect({...inspect,property_address:e?.target?.value})}}
              style={{
                outline: "none",
                border: "none",
                borderBottom: "1px solid black",
                width: "90%"
              }}
            />
          </span>
        </td>
      </tr>
      <tr>
        <td>
          <span style={{ fontWeight: 600 }}>
            CONTRACT DATE:
            <input
              type="date"
              value={inspect?.contract_date}
              onChange={(e)=>{SetInspect({...inspect,contract_date:e?.target?.value})}}
              style={{
                outline: "none",
                border: "none",
                borderBottom: "1px solid black",
                width: "85%"
              }}
            />
          </span>
        </td>
      </tr>
      <tr>
        <td>
          <span style={{ fontSize: 12 }}>
            Buyer and Seller have entered into an agreement for the sale of the
            above-described property. This document is authorization by the
            Buyer to order inspections and services at the Buyer's expense.
            Seller is authorizing access to the property for these inspections
          </span>
        </td>
      </tr>
      <tr>
        <td>
          <span style={{ fontWeight: 600, fontSize: 12 }}>
            AT THIS TIME, Buyer requests the following inspections (to be
            completed within the time allotted in the Purchase Agreement):{" "}
            <br />
            (Please Initial)
          </span>
        </td>
      </tr>
      <tr>
        <td>
          <span>
            {" "}
            <span style={{ paddingRight: 15 }}>
              <input type="text" 
                value={offerdetails?.lead_firstname?.charAt(0) + offerdetails?.lead_lastname?.charAt(0)}
              style={{ width: 25 }} />{" "}
              <input type="text" 
               value={inspect?.whole_inspection_input2}
               onChange={(e)=>{SetInspect({...inspect,whole_inspection_input2:e?.target?.value})}}
              style={{ width: 25 }} />{" "}
            </span>
            WHOLE HOUSE INSPECTION
          </span>
        </td>
      </tr>
      <tr>
        <td style={{ padding: "0px 0px 0px 65px" }}>
          <span style={{ fontSize: 12 }}>
            Performed by:
            <input
              type="text"
              value={inspect?.whole_inspection_performedby}
              onChange={(e)=>{SetInspect({...inspect,whole_inspection_performedby:e?.target?.value})}}
              style={{
                outline: "none",
                border: "none",
                borderBottom: "1px solid black",
                width: "50%"
              }}
            />
          </span>
        </td>
      </tr>
      <tr>
        <td>
          <span>
            {" "}
            <span style={{ paddingRight: 15 }}>
              <input type="text"
               value={offerdetails?.lead_firstname?.charAt(0) + offerdetails?.lead_lastname?.charAt(0)}
                //  onChange={(e)=>{SetInspect({...inspect,termite_wood_input1:e?.target?.value})}}
              style={{ width: 25 }} />{" "}
              <input type="text" 
                 value={inspect?.termite_wood_input2}
                 onChange={(e)=>{SetInspect({...inspect,termite_wood_input2:e?.target?.value})}}
              style={{ width: 25 }} />
            </span>{" "}
            TERMITE AND WOOD-DESTROYING INSECTS
          </span>
        </td>
      </tr>
      <tr>
        <td style={{ padding: "0px 0px 0px 65px" }}>
          <span style={{ fontSize: 12 }}>
            Performed by:
            <input
              type="text"
              value={inspect?.termite_wood_performedby}
              onChange={(e)=>{SetInspect({...inspect,termite_wood_performedby:e?.target?.value})}}
              style={{
                outline: "none",
                border: "none",
                borderBottom: "1px solid black",
                width: "50%"
              }}
            />
          </span>
        </td>
      </tr>
      <tr>
        <td>
          <span>
            {" "}
            <span style={{ paddingRight: 15 }}>
              <input type="text" 
            value={offerdetails?.lead_firstname?.charAt(0) + offerdetails?.lead_lastname?.charAt(0)}
       
              style={{ width: 25 }} />{" "}
              <input type="text" 
               value={inspect?.mold_input2}
               onChange={(e)=>{SetInspect({...inspect,mold_input2:e?.target?.value})}}
              style={{ width: 25 }} />
            </span>{" "}
            MOLD
          </span>
        </td>
      </tr>
      <tr>
        <td style={{ padding: "0px 0px 0px 65px" }}>
          <span style={{ fontSize: 12 }}>
            Performed by:
            <input
              type="text"
              value={inspect?.mold_performedby}
              onChange={(e)=>{SetInspect({...inspect,mold_performedby:e?.target?.value})}}
              style={{
                outline: "none",
                border: "none",
                borderBottom: "1px solid black",
                width: "50%"
              }}
            />
          </span>
        </td>
      </tr>
      <tr>
        <td>
          <span>
            {" "}
            <span style={{ paddingRight: 15 }}>
              <input type="text"
                value={offerdetails?.lead_firstname?.charAt(0) + offerdetails?.lead_lastname?.charAt(0)}
             
              style={{ width: 25 }} />{" "}
              <input type="text"
                value={inspect?.radon_input2}
                onChange={(e)=>{SetInspect({...inspect,radon_input2:e?.target?.value})}}
              style={{ width: 25 }} />
            </span>{" "}
            RADON
          </span>
        </td>
      </tr>
      <tr>
        <td style={{ padding: "0px 0px 0px 65px" }}>
          <span style={{ fontSize: 12 }}>
            {" "}
            Performed by:
            <input
              type="text"
              value={inspect?.radon_performedby}
              onChange={(e)=>{SetInspect({...inspect,radon_performedby:e?.target?.value})}}
              style={{
                outline: "none",
                border: "none",
                borderBottom: "1px solid black",
                width: "50%"
              }}
            />
          </span>
        </td>
      </tr>
      <tr>
        <td>
          <span>
            {" "}
            <span style={{ paddingRight: 15 }}>
              <input type="text" 
             value={offerdetails?.lead_firstname?.charAt(0) + offerdetails?.lead_lastname?.charAt(0)}
           
              style={{ width: 25 }} />{" "}
              <input type="text" 
                value={inspect?.furnace_air_condition_input2}
                onChange={(e)=>{SetInspect({...inspect,furnace_air_condition_input2:e?.target?.value})}}
              style={{ width: 25 }} />
            </span>{" "}
            FURNACE AND AIR CONDITIONING
          </span>
        </td>
      </tr>
      <tr>
        <td style={{ padding: "0px 0px 0px 65px" }}>
          <span style={{ fontSize: 12 }}>
            Performed by:
            <input
              type="text"
              value={offerdetails?.lead_firstname?.charAt(0) + offerdetails?.lead_lastname?.charAt(0)}
              style={{
                outline: "none",
                border: "none",
                borderBottom: "1px solid black",
                width: "50%"
              }}
            />
          </span>
        </td>
      </tr>
      <tr>
        <td>
          <span>
            {" "}
            <span style={{ paddingRight: 15 }}>
              <input type="text"
      value={offerdetails?.lead_firstname?.charAt(0) + offerdetails?.lead_lastname?.charAt(0)}
             
              style={{ width: 25 }} />{" "}
              <input type="text"
              value={inspect?.well_and_septic_input2}
              onChange={(e)=>{SetInspect({...inspect,well_and_septic_input2:e?.target?.value})}}
              style={{ width: 25 }} />
            </span>{" "}
            WELL AND/OR SEPTIC
          </span>
        </td>
      </tr>
      <tr>
        <td style={{ padding: "0px 0px 0px 65px" }}>
          <span style={{ fontSize: 12 }}>
            Performed by:
            <input
              type="text"
              value={inspect?.well_and_septic_performedby}
              onChange={(e)=>{SetInspect({...inspect,well_and_septic_performedby:e?.target?.value})}}
              style={{
                outline: "none",
                border: "none",
                borderBottom: "1px solid black",
                width: "50%"
              }}
            />
          </span>
        </td>
      </tr>
      <tr>
        <td>
          <span>
            {" "}
            <span style={{ paddingRight: 15 }}>
              <input type="text" 
               value={offerdetails?.lead_firstname?.charAt(0) + offerdetails?.lead_lastname?.charAt(0)}
           
              style={{ width: 25 }} />{" "}
              <input type="text" 
                 value={inspect?.sewer_line_input2}
                 onChange={(e)=>{SetInspect({...inspect,sewer_line_input2:e?.target?.value})}}
              style={{ width: 25 }} />
            </span>{" "}
            SEWER LINE (RECOMMENDED ON ALL HOMES OVER 20 + YEARS OLD)
          </span>
        </td>
      </tr>
      <tr>
        <td style={{ padding: "0px 0px 0px 65px" }}>
          <span style={{ fontSize: 12 }}>
            Performed by:
            <input
              type="text"
              value={inspect?.sewer_line_performedby}
              onChange={(e)=>{SetInspect({...inspect,sewer_line_performedby:e?.target?.value})}}
              style={{
                outline: "none",
                border: "none",
                borderBottom: "1px solid black",
                width: "50%"
              }}
            />
          </span>
        </td>
      </tr>
      <tr>
        <td>
          <span>
            {" "}
            <span style={{ paddingRight: 15 }}>
              <input type="text" 
        value={offerdetails?.lead_firstname?.charAt(0) + offerdetails?.lead_lastname?.charAt(0)}
            
              style={{ width: 25 }} />{" "}
              <input type="text" 
                 value={inspect?.other_input2}
                 onChange={(e)=>{SetInspect({...inspect,other_input2:e?.target?.value})}}
              style={{ width: 25 }} />
            </span>{" "}
            OTHER:
          </span>
        </td>
      </tr>
      <tr>
        <td style={{ padding: "0px 0px 0px 65px" }}>
          <span style={{ fontSize: 12 }}>
            Performed by:
            <input
              type="text"
              value={inspect?.other_performedby}
              onChange={(e)=>{SetInspect({...inspect,other_performedby:e?.target?.value})}}
              style={{
                outline: "none",
                border: "none",
                borderBottom: "1px solid black",
                width: "50%"
              }}
            />
          </span>
        </td>
      </tr>
      <tr>
        <td>
          <span style={{ fontWeight: 600 }}>
            BUYER AND SELLER (as applicable) agree and acknowledge that
          </span>
        </td>
      </tr>
      <tr>
        <td style={{ fontSize: 14 }}>
          <ul>
            <li>
              Inspections or services ordered but not used, due to the sale
              failing to close, will be paid by the Buyer (except as otherwise
              provided in the Purchase Agreement) and shall not become the
              responsibility or the expense of the agent or the seller
            </li>
            <li>
              The parties have received the Affiliated Business Disclosure
              Agreement outlining potential financial benefits by the Broker
            </li>
            <li>
              The following entities may contact the buyer or seller regarding
              the sale and closing of the above mentioned property: inspectors
              and service providers and any other persons or companies
              specifically engaged by either party to facilitate the purchase of
              the Property involved herein.{" "}
            </li>
            <li>
              YOU ARE RESPONSIBLE to satisfy yourself as to the specifications,
              quality and price of services to be performed by any inspector or
              company you choose. THE COMPANY YOU CHOOSE TO USE IS AT YOUR
              DISCRETION AND DIRECTION.
            </li>
            <li>
              Buyer may be required to pay for inspections at the time of
              inspection and should be prepared to do so.{" "}
              <span style={{ textDecoration: "underline" }}>
                SHALL NOT BE SENT ANY INSPECTION RESULTS UNLESS SPECIFICALLY
                REQUESTED BY SELLER'S AGENT. IF SELLER DOES REQUEST THE
                INSPECTION RESULTS, THE RELEVANT PORTIONS SHOULD BE PROVIDED
                WITHIN 48 HOURS OF THE REQUEST
              </span>{" "}
            </li>
          </ul>
        </td>
      </tr>
      <tr>
        <td>
          <span style={{ fontSize: 12 }}>
            <span style={{ fontWeight: 600 }}>Notification to Seller:</span>{" "}
            Within seven (7) business days after acceptance of the Purchase
            Agreement, the Purchaser may deliver notification in writing to the
            Seller of matters disclosed by the foregoing inspections that
            pertain to material defects for which the Purchaser is requesting
            repair. If the Purchaser does not make such a written notification
            to the Seller within seven (7) business days of final acceptance of
            the Purchase Agreement, the property shall be deemed to be
            acceptable to the Purchaser, and this inspection contingency deemed
            released.{" "}
          </span>
        </td>
      </tr>
      <tr>
        <td>
          <span style={{ fontSize: 12 }}>
            <span style={{ fontWeight: 600 }}>If Defects are Found: </span>{" "}
            timely notification of defects is delivered to the Seller, the
            Seller shall deliver a response to the Purchaser within five (5)
            business days thereafter stating what steps the Seller will take
            before closing to correct any defects described in Purchaser's
            notification. The Purchaser shall within two (2) business days
            following delivery of the Sellers' proposed remedies deliver
            notification in writing to the Seller that such steps are
            acceptable, in which case the notifications outlined in this
            Inspection Addendum to the Purchase Agreement shall be binding upon
            all parties. If the Seller fails to propose remedies for the
            defects, or if the Purchaser reasonably determines that such
            remedies are not acceptable, at the option of the Purchaser, the
            Purchaser may provide written notice to the Seller that the Purchase
            Agreement is terminated, and the same shall thereafter be deemed
            null and void.
          </span>
        </td>
      </tr>
      <tr>
        <td>
          <span>
            Each inspector must be licensed, if applicable, in the jurisdiction
            in which the subject property is located. The cost of inspections
            shall be the sole responsibility of the Purchaser.
          </span>
        </td>
      </tr>
      <tr>
          <td style={{padding: '15px 0px'}}>
              <table style={{width: '100%', tableLayout: "fixed"}}>
                  <tr>
                      <td>
                      <img src={user === "client" ? (val || inspect?.buyer1_signature) : inspect?.buyer1_signature} alt="" style={{width: '100%', maxWidth: '230px'}}/><br />
                          Buyer
                      </td>
                      <td>
                      <input type="date" value={inspect?.buyer1_signature_date ? inspect?.buyer1_signature_date : (user === "client" && val || inspect?.buyer1_signature) ? new Date().toISOString().split('T')[0] : ""}  
                      onChange={(e)=>{SetInspect({...inspect,buyer1_signature_date:e?.target?.value})}} name="" id="" /><br />
                          date
                      </td>
                      <td>
                      <img src={user === "seller" ? (val || inspect?.seller1_signature) : inspect?.seller1_signature} alt=""  style={{width: '100%', maxWidth: '230px'}}/><br />
                          Seller
                      </td>
                      <td>
                      <input type="date" value={inspect?.seller1_signature_date ? inspect?.seller1_signature_date : (user === "seller" && val || inspect?.seller1_signature) ? new Date().toISOString().split('T')[0] : ""}  
                      onChange={(e)=>{SetInspect({...inspect,seller1_signature_date:e?.target?.value})}} name="" id="" /><br />
                          date
                      </td>
                  </tr>

              </table>
          </td>
            </tr>
            <tr>
                <td style={{padding: '15px 0px'}}>
                    <table style={{width: '100%', tableLayout: "fixed"}}>
                        <tr>
                            <td>
                            <input
                              type="text"
                              style={{
                                outline: "none",
                                border: "none",
                                borderBottom: "1px solid black",
                                width: 250
                              }}
                            /><br/>
                                Buyer
                            </td>
                            <td>
                                <input type="date"/><br />
                                Date
                            </td>
                            <td>
                              <input
                                type="text"
                                style={{
                                  outline: "none",
                                  border: "none",
                                  borderBottom: "1px solid black",
                                  width: 250
                                }}
                              /><br/>
                                Seller
                            </td>
                            <td>
                                <input type="date"/><br />
                                Date
                            </td>
                        </tr>

                    </table>
                </td>
            </tr>
      {/* <tr>
        <td>
          <table>
            <tbody>
              <tr>
                <td style={{ textAlign: "center" }}>
                  <span>
                    <input
                      type="text"
                      style={{
                        outline: "none",
                        border: "none",
                        borderBottom: "2px solid #3b0083",
                        width: 500
                      }}
                    />
                  </span>
                  <span style={{ paddingRight: 250 }}> Buyer 
                  <img     src={user === "client" ? (val || inspect?.buyer1_signature) : inspect?.buyer1_signature} alt="" />
                  </span>Date
                  <input type="date" value={inspect?.buyer1_signature_date}  onChange={(e)=>{SetInspect({...inspect,buyer1_signature_date:e?.target?.value})}} name="" id="" />
                </td>
                <td style={{ textAlign: "center" }}>
                  <span>
                    <input
                      type="text"
                      style={{
                        outline: "none",
                        border: "none",
                        borderBottom: "2px solid #3b0083",
                        width: 500
                      }}
                    />
                  </span>
                  <span style={{ paddingRight: 250 }}> Seller
                  <img     src={user === "seller" ? (val || inspect?.seller1_signature) : inspect?.seller1_signature} alt="" />
                  </span>Date

                  <input type="date" value={inspect?.seller1_signature_date}  onChange={(e)=>{SetInspect({...inspect,seller1_signature:e?.target?.value})}} name="" id="" />
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr> */}
      {/* <tr>
        <td>
          <table>
            <tbody>
              <tr>
                <td style={{ textAlign: "center" }}>
                  <span>
                    <input
                      type="text"
                      style={{
                        outline: "none",
                        border: "none",
                        borderBottom: "2px solid #3b0083",
                        width: 500
                      }}
                    />
                  </span>
                  <span style={{ paddingRight: 250 }}> Buyer </span>Date
                  <input type="date" value={inspect?.buyer2_signature_date}  onChange={(e)=>{SetInspect({...inspect,buyer2_signature_date:e?.target?.value})}} name="" id="" />
                </td>
                <td style={{ textAlign: "center" }}>
                  <span>
                    <input
                      type="text"
                      style={{
                        outline: "none",
                        border: "none",
                        borderBottom: "2px solid #3b0083",
                        width: 500
                      }}
                    />
                  </span>
                  <span style={{ paddingRight: 250 }}> Seller</span>Date
                  <input type="date" value={inspect?.seller2_signature_date}  onChange={(e)=>{SetInspect({...inspect,seller2_signature_date:e?.target?.value})}} name="" id="" />
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr> */}
      <tr>
        <td>
          <span>
            Other provisions: Earnest deposit to be delivered within (5)
            business days.
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</>
<React.Fragment>
<div className="d-flex align-items-center justify-content-end mb-2 mr-2">
    <button onClick={send} className="btn primaryColorBtn">Submit
    {loader && <CSpinner color="dark" size="sm" className={'ml-1'} />}
    </button>
    <button onClick={printf} className="btn print-doc-btn mx-2">Print</button>
    <button className="signaturebtn btn mb-0" onClick={() => setCanvasModal()}>Signature</button> 
</div>
          </React.Fragment>

  <Esign
        canvasmodal={canvasmodal}
        setCanvasModal={setCanvasModal}
        htmlContent={htmlContent}
        setHtmlContent={setHtmlContent}
        selecteddocumentesign={selecteddocumentesign}
        setselectedDocumentEsign={setselectedDocumentEsign}
        type={"seller"}
      ></Esign>
        </>
    )
}
export default ReqInspectionAuth